// extracted by mini-css-extract-plugin
export var billingAddress = "_xv-g";
export var contactInfo = "_xv-d";
export var customerInfoContainer = "_xv-c";
export var customerInfoContainerMobile = "_xv-h";
export var customerInfoRow = "_xv-a";
export var customerInfoSection = "_xv-b";
export var fullWidthDividerMobile = "_xv-i";
export var imageContainer = "_xv-1";
export var paymentMethod = "_xv-e";
export var priceText = "_xv-6";
export var priceTextMobile = "_xv-7";
export var product = "_xv-0";
export var productImage = "_xv-2";
export var productInfo = "_xv-4";
export var productMobile = "_xv-9";
export var productTitle = "_xv-8";
export var quantityBadge = "_xv-3";
export var quantityText = "_xv-5";
export var shippingAddress = "_xv-f";